module.exports = __webpack_public_path__ + "images/game/christmas-decoration.8f158e3b95c0396b92840cab2a31a4ee.png";